import React, { useState } from 'react';

const StarterAppContext = React.createContext([]);

const StarterAppProvider = props => {

    const [personalDetails, setPersonalDetails] = useState({
        title: '',
        firstName: '',
        middleName: '',
        lastName: '',
    });

    const [contactDetails, setContactDetails] = useState({
        phoneNumber: '',
        emailAddress: '',
        residentialAddress: '',
    });

    const [propertyDetails, setPropertyDetails] = useState({
        impactedAddress: '',
        isResidentialAddress: '',
        relatedDamage: '',
        propertyRelationship: '',
        propertyOwners: '',
        otherSituation: '',
        isPrimaryResidence: '',
        isPropertyInsured: '',
        insuranceProvider: '',
        isCleanedUp: '',
        cleanedUpInfo: '',
        isRegistered: '',
        hasMoreProperties: '',
        propertyCount: '',
    });

    const [abrDetails, setAbrDetails] = useState({
        abnCharityType: {
            status: '',
            description: null,
            effectiveFrom: null,
            effectiveTo: null
        },
        abnEntityName: '',
        abnEntityStatus: {
            status: '',
            statusCode: '',
            effectiveFrom: '',
            effectiveTo: ''
        },
        abnEntityType: '',
        abnGstStatus: {
            status: '',
            registered: null,
            effectiveFrom: '',
            effectiveTo: ''
        },
        abnLocation: {
            location: '',
            stateCode: '',
            postCode: ''
        },
        abnTradingName: '',
        bankAccountBsb: '',
        bankAccountName: '',
        bankAccountNumber: '',
        businessAddress: '',
        businessEmail: '',
        businessName: '',
        businessPhone: '',
        id: '',
        identifier: '',
        identifierType: '',
        postalAddress: '',
        role: ''
    });

    return (
        <StarterAppContext.Provider value={[
            personalDetails, setPersonalDetails,
            contactDetails, setContactDetails,
            propertyDetails, setPropertyDetails,
            abrDetails, setAbrDetails
        ]}>
            {props.children}
        </StarterAppContext.Provider>
    );
};

export { StarterAppContext, StarterAppProvider };
